'use client';

import createTheme from './createTheme';
import useThemeWithoutDefault from './useThemeWithoutDefault';
export const systemDefaultTheme = createTheme();
function useTheme(defaultTheme = systemDefaultTheme) {
  return useThemeWithoutDefault(defaultTheme);
}
export default useTheme;


//////////////////
// WEBPACK FOOTER
// ../@mui/system/esm/useTheme.js
// module id = 185
// module chunks = 22